module.exports = __webpack_public_path__ + "static/media/i8-vip-icon.27cce575.svg";